import { format } from 'date-fns';

import type { Locale } from 'date-fns';

type FormatModalApptTimeOptions = {
  locale?: Locale;
};

const formatModalApptTime = (
  startTime: string,
  endTime: string,
  { locale }: FormatModalApptTimeOptions = {},
): string => {
  const from = format(startTime, 'd MMMM p', { locale });

  const formattedFrom = from.replace(/(\d{1,2}):/, '\n$1:');
  const to = format(endTime, ' — p', { locale });

  return formattedFrom + to;
};

export { formatModalApptTime };
